/**
 * * Тип меню
 */
export enum MenuItemType {
  /** Рабочая область */
  WorkingArea = "area",
  /** Папка */
  Folder = "folder",
  /** Очередь */
  List = "list",
}
